import React from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { Container } from "@material-ui/core";

import DataFlowDiagram from "../../../images/gdp-new.svg";


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#000",
  },
  title: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 36,
    fontWeight: 800,
    color: theme.palette.text.hint,
  },
  content: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 18,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3),
  },
  dataFlow: {
    height: "75vh",
    cursor: "pointer",
    padding: theme.spacing(2),
    display: "flex",
    alignItems: "center",
  }
}));

export default function Feature4() {
  const classes = useStyles();

  return (
    <Container maxWidth="lg">
      <div className={classes.root}>
        <Grid container>
          <Grid item xs={12}>
            <p className={classes.title}>Unified Data Platform</p>
            <p className={classes.content}>Your Data, Your AI, Your Future</p>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12} className={classes.dataFlow}>
                <img src={DataFlowDiagram} width={"100%"} alt="data-flow-diagram"/>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
}